import createMailFolderTableQuery from 'mini-mail-list-store/lib/utils/tables/createMailFolderTableQuery';
import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';
import loadTableViewFromTableQuery from 'mini-mail-list-actions/lib/actions/tables/loadTableViewFromTableQuery';
import { addVisibilityChangeListener } from 'dom-utils/lib/utils/addVisibilityChangeListener';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { trace } from 'owa-trace';
import { useEffect } from 'react';

const REFRESH_AFTER_TIME_IN_BACKGROUND = 60 * 60 * 1000; // 60 minutes

/**
 * Refreshes the mail-list if mail module transitions to foreground after
 * being in the background.
 * Enabled only for Outlook Lite for now.
 */
export const useRefreshMailListOnVisibilityChange = (
    refreshAfter = REFRESH_AFTER_TIME_IN_BACKGROUND
) => {
    useEffect(() => {
        if (isMiniHostAppFeatureEnabled('native')) {
            const removeListenerCallback = addVisibilityChangeListener(
                ({ visibilityState, dwellTime }) => {
                    if (visibilityState === 'visible' && dwellTime > refreshAfter) {
                        trace.info(
                            `[useRefreshMailListOnVisibilityChange] Refreshing mail-list. Dwell time: ${dwellTime}ms.`
                        );
                        const tableQuery = createMailFolderTableQuery(getSelectedFolderId());
                        loadTableViewFromTableQuery(tableQuery, null, true);
                    }
                }
            );

            return removeListenerCallback;
        }
        return undefined;
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useEffect has a missing dependency: 'refreshAfter'. Either include it or remove the dependency array. */
    }, []);
};
